/**
 * 画像アセットの論理名 → パス マップ。
 *
 * 画面コードは生パス ('/assets/help/domain.png') を直書きせず、ここを参照する:
 *   import { IMG } from '../theme/assets';
 *   <Box component="img" src={IMG.help.domain} />
 *
 * 実体は frontend/public/assets/ 配下 (カテゴリ別フォルダ・意味のあるファイル名)。
 * 画像を差し替え/リネームする場合はこのファイルだけ直せばよい。
 */
export const IMG = {
  /** マスコットふくろう (各画面のヒーロー/アクション) */
  owl: {
    /** 探偵ふくろうの大きなヒーローシーン (ホーム/ログイン/ヘルプ/招待) */
    hero: '/assets/owl/hero.png',
    /** クリップボードを持つふくろう (抽出後レビュー/検証中/結果/動画処理のヒーロー) */
    clipboard: '/assets/owl/clipboard.png',
    /** 検証導線: ドキュメント */
    methodDocument: '/assets/owl/method-document.png',
    /** 検証導線: 動画 */
    methodVideo: '/assets/owl/method-video.png',
    /** 検証導線: ドメイン限定 */
    methodDomain: '/assets/owl/method-domain.png',
    /** AIフォローアップ パネル見出し */
    followupPanel: '/assets/owl/followup-panel.png',
  },
  /** 判定シール。error は判定ではなく処理の失敗を表す */
  verdict: {
    accurate: '/assets/verdict/accurate.png',
    inaccurate: '/assets/verdict/inaccurate.png',
    partial: '/assets/verdict/partial.png',
    unverifiable: '/assets/verdict/unverifiable.png',
    error: '/assets/verdict/error.svg',
  },
  /** アイテム種別アイコン (マイアイテム等) */
  item: {
    document: '/assets/item/document.png',
    video: '/assets/item/video.png',
  },
  /** プレビュー見出しアイコン */
  preview: {
    document: '/assets/preview/document.png',
    video: '/assets/preview/video.png',
  },
  /** 新規作成 (ドロップゾーン/種別) */
  create: {
    pdf: '/assets/create/pdf.png',
    video: '/assets/create/video.png',
    upload: '/assets/create/upload.png',
  },
  /** 動画処理ステージ */
  process: {
    transcribe: '/assets/process/transcribe.png',
    extract: '/assets/process/extract.png',
    complete: '/assets/process/complete.png',
  },
  /** 調査チャット (エージェント/対象) */
  investigate: {
    strategy: '/assets/investigate/strategy.png',
    webSearch: '/assets/investigate/web-search.png',
    /** 検索期間を指定するモーダル */
    period: '/assets/investigate/period.png',
    target: '/assets/investigate/target.png',
  },
  /** チャット (アシスタントふくろうアバター) */
  chat: {
    avatar: '/assets/chat/avatar.png',
  },
  /** 案件 */
  workspace: {
    folders: '/assets/workspace/folders.png',
    owl: '/assets/workspace/owl.png',
    /** 招待（グループ共有の使い方 2つ目） */
    invite: '/assets/workspace/invite.png',
    /** 案件に共有するモーダルの見出し */
    share: '/assets/workspace/share.png',
  },
  /** 規程チェック */
  compliance: {
    /**
     * もとの素材を見るモーダルの見出し。書類とカチンコを並べた絵で、動画・ドキュメントの
     * 両方を指す。「引用の確認方法」モーダル（資料・動画のどちらも対象）でも使っている。
     */
    preview: '/assets/compliance/preview.png',
    /** 盾を持つふくろう。ヘルプの「放送規程チェック」カードの絵 */
    owlShield: '/assets/compliance/owl-clear.png',
  },
  /** グループ共有の使い方3手順。小さく置くので線ではなく二色の面で描いてある */
  share: {
    stepGroup: '/assets/share/step-group.svg',
    stepInvite: '/assets/share/step-invite.svg',
    stepProject: '/assets/share/step-project.svg',
  },
  /** 設定タブ */
  settings: {
    owlGear: '/assets/settings/owl-gear.png',
    appearance: '/assets/settings/appearance.png',
    account: '/assets/settings/account.png',
    group: '/assets/settings/group.png',
  },
  /** ヘルプ 機能ガイド */
  help: {
    document: '/assets/help/document.png',
    video: '/assets/help/video.png',
    followup: '/assets/help/followup.png',
    domain: '/assets/help/domain.png',
  },
  /** ヒーロー背景 (任意) */
  heroBg: {
    light: '/assets/gen/hero-bg-3.png',
    warm: '/assets/gen/hero-bg-1.png',
    cool: '/assets/gen/hero-bg-2.png',
  },
} as const;

export default IMG;
